module.exports = __webpack_public_path__ + "img/Feature.78767c8a.png";